"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const mithril_1 = __importDefault(require("mithril"));
const stream_1 = __importDefault(require("mithril/stream"));
const JSONStorageItem_1 = __importDefault(require("../JSONStorageItem"));
const stravaApi_1 = require("../stravaApi");
const Viewer_1 = __importDefault(require("./Viewer"));
const Welcome_1 = __importDefault(require("./Welcome"));
const actDataStorage = new JSONStorageItem_1.default('actData');
const tokenStorage = new JSONStorageItem_1.default('token');
const syncDateStorage = new JSONStorageItem_1.default('syncDate');
const Index = () => {
    // This is a stream containing a complete set of all the user's activities
    const actData$ = (0, stream_1.default)(undefined);
    const actDataFromLS = actDataStorage.get();
    if (actDataFromLS) {
        actData$(actDataFromLS);
    }
    actData$.map((actData) => {
        if (actData) {
            actDataStorage.set(actData);
        }
    });
    // This is a stream containing the (possibly partial) set of activities being downloaded for the user
    const actDataSync$ = (0, stream_1.default)();
    // This is a stream containing the last sync date
    const syncDate$ = (0, stream_1.default)();
    const syncDateFromLS = syncDateStorage.get();
    if (syncDateFromLS) {
        syncDate$(syncDateFromLS);
    }
    syncDate$.map((syncDate) => {
        syncDateStorage.set(syncDate);
    });
    // Grab token from the search param, if there is one
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromSP = urlParams.get('token');
    if (tokenFromSP) {
        tokenStorage.setRaw(tokenFromSP);
        window.history.replaceState({}, '', '/');
        sync({ fromScratch: true }); // if we just authed, we should certainly sync
    }
    else {
        // Try using token in LS
        let token = tokenStorage.get();
        if (token) {
            // If it's been long enough, get a sync going
            const syncDate = syncDate$();
            if (!syncDate || +new Date() - syncDate > 1000 * 60 * 60) {
                sync({ fromScratch: false });
            }
        }
    }
    function sync({ fromScratch }) {
        return __awaiter(this, void 0, void 0, function* () {
            let token = tokenStorage.get();
            if (token) {
                // Refresh the token if necessary
                if (token.expires_at * 1000 < +new Date()) {
                    token = yield mithril_1.default.request({
                        url: `/api/submit-refresh-token?refresh_token=${token.refresh_token}`,
                    });
                    // TODO: error handling
                    tokenStorage.set(token);
                }
                let afterTime = undefined;
                let actData = actData$();
                if (!fromScratch && actData && actData.length > 0) {
                    actDataSync$(actData);
                    const times = actData.map((act) => +new Date(act.start_date) / 1000);
                    afterTime = lodash_1.default.max(times);
                }
                else {
                    actDataSync$([]);
                }
                yield (0, stravaApi_1.fetchActivities)(token.access_token, (newActData) => {
                    // This runs whenever a new page of data comes in
                    if (fromScratch) {
                        actDataSync$(newActData);
                    }
                    else {
                        actDataSync$([...actData$() || [], ...newActData]);
                    }
                    mithril_1.default.redraw();
                }, undefined, afterTime);
                actData$(actDataSync$());
                actDataSync$(undefined);
                syncDate$(+new Date());
            }
            else {
                window.location.href = 'api/redirect-to-auth';
            }
        });
    }
    return {
        view: () => {
            // To test the welcome screen:
            // return m(Welcome, {actDataSync$: Stream() as any});
            // To test the loading screen:
            // return m(Welcome, {actDataSync$: Stream([]) as any});
            if (actData$()) {
                return (0, mithril_1.default)(Viewer_1.default, { actData$: actData$, actDataSync$, syncDate$, sync });
            }
            else {
                return (0, mithril_1.default)(Welcome_1.default, { actDataSync$ });
            }
        },
    };
};
exports.default = Index;
